import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { emailMasterApis } from '../../constants/email-master';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
  providedIn: 'root'
})
export class EmailMasterService {
  permissions_entity = permissionEntity;
  
  constructor(
    private httpClientService: HttpClientService,
    private _permissionPipe: PermissionsPipe // dont remove this
  ) { }

  getEmailTemplate(pagination: PaginationType,filters?: any, type?): Observable<any> {
    let query = '?';
    if (type) {
      query += `type=${type}&`;
    }
    if (filters) {
        query += filters;
    }
    query += userParams.call(this, this.permissions_entity.modules.email_template);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${emailMasterApis.getTemplates}${query}`);
  }

  sendMail(from: any, payload: any): Observable<any> {
    return this.httpClientService.upload(
      `${emailMasterApis.sendMail}${from}`,
      payload
    );
  }

  sendMailTemplate(from: any, payload: any): Observable<any> {
    return this.httpClientService.upload(
      `${emailMasterApis.sendEMailTemplate}${from}`,
      payload
    );
  }

  getTemplateById(id: string): Observable<any> {
    return this.httpClientService.get(`${emailMasterApis.templateById}/${id}`);
  }

  createTemplate(payload: any): Observable<any> {
    return this.httpClientService.post(
      emailMasterApis.createTemplate,
      payload
    );
  }

  editTemplate(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${emailMasterApis.updateTemplate}${id}`, payload);
  }

  deleteTemplate(id): Observable<any> {
    return this.httpClientService.delete(`${emailMasterApis.deleteTemplate}?id=${id}`);
  }

  getEmailEvents(pagination: PaginationType): Observable<any> {
    let query = '?';
    query += userParams.call(this, this.permissions_entity.modules.email_events);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${emailMasterApis.getEvenst}${query}`);
  }

  createEvents(payload: any): Observable<any> {
    return this.httpClientService.post(
      emailMasterApis.createEvents,
      payload
    );
  }

  editEvent(id: any, payload: any): Observable<any> {
    return this.httpClientService.put(`${emailMasterApis.editEvents}${id}`, payload);
  }

  deleteEvent(id): Observable<any> {
    return this.httpClientService.delete(`${emailMasterApis.deleteEvents}?id=${id}`);
  }

  getEmailSubject(params: any): Observable<any> {
    let query = '';
    if (params?.course_id) {
      query += `&courseType=${params.course_id}`;
    }
    return this.httpClientService.get(
      `${emailMasterApis.getEmailSubject}${params.c_id}&universityId=${params.u_id}&universityCountryId=${params.uni_c_Id}${query}`);
  }

  getEmailtemplateByTempId(params: any): Observable<any> {
    return this.httpClientService.get(
      `${emailMasterApis.emailTemplateById}${params.temp_id}&applicationId=${params.app_id}&userId=${params.user_id}`
      );
  }

  checkEligibility(id: any): Observable<any> {
    return this.httpClientService.get(
      `${emailMasterApis.checkEligibilityBy}${id}`
    );
}
}
